@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../popover/style.scss' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	.kol-split-button {
		display: flex;
		position: relative;
		width: 100%;
		&__root {
			display: flex;
			position: relative;
			width: 100%;
			align-items: stretch;
		}
		&__button {
			min-width: 0;
			flex: 1 1 auto;
			text-align: left;
		}

		.kol-popover {
			z-index: 1;

			&__content {
				margin-top: to-rem(2);
			}

			&__arrow {
				display: none;
			}
		}
	}
}
